import { combineReducers } from "redux";
import axios from 'axios';
import _ from 'lodash';
import * as Urls from 'src/constants/EndpointUrls';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import { fetchList, fetchListSuccess, fetchListFailure } from 'src/reducers/common/listReducer';
import { serializeHttpGetParams } from 'src/utils/Http';

export const REDUCER_NAME = 'yearEndReportKt20Kor';

export const fetchKt20KorData = formValues => async dispatch => {
  try {
    dispatch(fetchList(REDUCER_NAME));
    const params = { clientCompanyId: formValues.clientCompanies, paymentYear: formValues.paymentYears };
    const url = `${Urls.SEARCH_KT20_KOR_DATA}?${serializeHttpGetParams(params)}`;
    const response = await axios.get(url);
    const payload = {
      data: {
        employeePay: response.data.payload.employeePay,
        clientOrClientBranch: response.data.payload.clientOrClientBranch
      }
    }
    dispatch(fetchListSuccess(REDUCER_NAME, payload));
  } catch (e) {
    dispatch(fetchListFailure(REDUCER_NAME, e.response.data.errors.messages));
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});